import React from "react";
import { CupSoda } from "lucide-react";
import AlimentazioneControllo from "../components/AlimentazioneControllo";

export default function NonBeve() {
  return (
    <AlimentazioneControllo
      tipo="beve"
      title="Non beve"
      subtitle="Controlla l'idratazione di ogni ospite. Segnala solo chi non ha bevuto, indicando quando e una nota."
      Icon={CupSoda}
      momentiOptions={["Mattina", "Pomeriggio", "Sera", "Notte"]}
      momentiLabel="Quando non ha bevuto"
      verbo="bevuto"
      flebiOptions={[{ v: "fisiologica", l: "Flebo idratante (fisiologica)" }, { v: "glucosata", l: "Flebo glucosata" }, { v: "altro", l: "Altro" }]}
      flebiLabel="Idratazione assistita via flebo"
      testid="non-beve"
    />
  );
}
